import { render, staticRenderFns } from "./PlotIndex.vue?vue&type=template&id=154165ae&scoped=true&"
import script from "./PlotIndex.vue?vue&type=script&lang=js&"
export * from "./PlotIndex.vue?vue&type=script&lang=js&"
import style0 from "./PlotIndex.vue?vue&type=style&index=0&id=154165ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154165ae",
  null
  
)

export default component.exports